import MatomoMessage from '@/matomo/message/MatomoMessage';
import MatomoContext from '@/matomo/domain/MatomoContext';

export default class MatomoContextMessage {
  protected message: MatomoMessage;

  protected constructor(message: MatomoMessage) {
    this.message = message;
  }

  public static from(message: MatomoMessage): MatomoContextMessage {
    return new MatomoContextMessage(message);
  }

  public publishWithContext(matomoContext: MatomoContext) {
    if (matomoContext.hasSource()) {
      this.getMessageFromContext(matomoContext).publish();
    }
  }

  protected getMessageFromContext(matomoContext: MatomoContext) {
    return this.message.with(matomoContext.source);
  }
}

export class MatomoSelfMessage extends MatomoContextMessage {
  protected getMessageFromContext(matomoContext: MatomoContext): MatomoMessage {
    return this.message.with(matomoContext.source + ' Self');
  }
}

export class MatomoRestoreMessage extends MatomoContextMessage {
  protected getMessageFromContext(matomoContext: MatomoContext): MatomoMessage {
    return this.message.with(matomoContext.source + ' Restore');
  }
}
